import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumStarlinks as LogoStarlinks } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/starlinks/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.starlinks.list'
  });
  useDocumentTitle(t('pageTitle'));
  const tabs = [{
    to: '/starlinks',
    children: t('tabs.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/starlinks/user-terminals',
    children: t('tabs.userTerminals'),
    activeOptions: {
      exact: true,
      includeSearch: true
    }
  }, {
    to: '/starlinks/alerts',
    children: t('tabs.alerts')
  }
  // {
  //   to: "/starlinks/marketplace",
  //   children: t("tabs.marketplace"),
  // },
  // {
  //   to: "/starlinks/billing-and-cost",
  //   children: t("tabs.billingAndCost"),
  // },
  // {
  //   to: "/starlinks/operation-activity",
  //   children: t("tabs.operationActivity"),
  // },
  ] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoStarlinks} name={t('pageTitle')} tabs={tabs} type="resource" sticky={false} />
      <Outlet />
    </div>;
}